import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import LabelSelect from '@/components/common/form/LabelSelect';
import ConstituentTypeSelect from '@/components/filters/ConstituentTypeSelect';
import ConstituentSearchFilterField from '@/constants/ConstituentSearchFilterField';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { ConstituentAssigneeSelect } from '@/modules/ConstituentDetails';
import { ConstituentCategorySelect } from '@/modules/ConstituentListView';
import TemporaryFilterField from '../constants/TemporaryFilterField';
import type ConstituentFilterFormData from '../types/ConstituentFilterFormData';

export default function QuickFiltersConstituent() {
  const { control } = useFormContext<ConstituentFilterFormData>();

  return (
    <div className="grid w-80 grid-cols-1 gap-3 px-2 py-3">
      <Controller
        control={control}
        name={ConstituentSearchFilterField.CONSTITUENT_TYPE}
        render={({ field: { onChange, value } }) => (
          <ConstituentTypeSelect value={value} onChange={onChange} />
        )}
      />
      <Controller
        control={control}
        name={ConstituentSearchFilterField.CONSTITUENT_CATEGORIES}
        render={({ field: { onChange, value } }) => (
          <ConstituentCategorySelect value={value} onChange={onChange} />
        )}
      />
      <Controller
        control={control}
        name={TemporaryFilterField.ASSIGNEE}
        render={({ field: { onChange, value } }) => (
          <ConstituentAssigneeSelect onChange={onChange} value={value} />
        )}
      />
      <Controller
        control={control}
        name={TemporaryFilterField.CONSTITUENT_LABELS}
        render={({ field: { onChange, value } }) => (
          <LabelSelect value={value} onChange={onChange} disableCloseOnSelect />
        )}
      />
    </div>
  );
}
